export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-background-color-d7bb1ece91314433200c5493b4e61f1f.svg";